export const getDepartments = (state) => state.departments

